import React, { useEffect } from 'react'
import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import useAttributes from 'utils/hooks/useAttributes'

import PostponedFormActionButtons from '../PostponedFormActionButtons'
import CheckList from 'components/CheckList'
import { MAX_POSTPONED_CONTENT_WIDTH, PostponedFormStepProps } from '..'
import { CatalogItem } from 'shared'

import { validationSchema } from './config'
import {
  POSTPONED_FORM_ATTRIBUTES,
  useAuth,
} from 'utils/providers/AuthProvider'

const ProductInterestsForm = ({
  onStepChange,
  step,
  updateProfile,
}: PostponedFormStepProps) => {
  const { attributes, isLoading } = useAttributes(
    POSTPONED_FORM_ATTRIBUTES.product_interests
  )
  const { user } = useAuth()

  const { content_types } = attributes

  const { control, handleSubmit, reset } = useForm<{
    content_types: { code: string; text: string }[]
  }>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      content_types: [],
    },
  })

  useEffect(() => {
    const types = user?.profile?.attributes?.find(
      (el) => el.type === 'content_types'
    )?.value
    reset({
      content_types: (types as CatalogItem[]) || [],
    })
  }, [user])

  const onSubmit = handleSubmit((data) => {
    updateProfile([
      {
        category: 'CONTENT',
        type: 'content_types',
        value: data.content_types,
      },
    ])
    onStepChange(step.id + 1)
  })

  if (isLoading) return null

  return (
    <>
      <Grid
        container
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{ maxWidth: MAX_POSTPONED_CONTENT_WIDTH }}
      >
        <Controller
          name="content_types"
          control={control}
          render={({ field, fieldState }) => {
            return (
              <Grid>
                <CheckList
                  title="Please select all of the categories you would be interested in creating a video review for"
                  error={fieldState.error?.message}
                >
                  {content_types?.options?.map((item) => {
                    const { code, text } = item
                    return (
                      <Grid key={code}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="mint"
                              size="small"
                              disableRipple
                              checked={
                                !!field.value?.find((el) => el.code === code)
                              }
                              onChange={() => {
                                if (
                                  field.value.find(
                                    (el) => el.code === item.code
                                  )
                                ) {
                                  field.onChange(
                                    field.value.filter(
                                      (el) => el.code !== item.code
                                    )
                                  )
                                } else {
                                  field.onChange([...field.value, item])
                                }
                              }}
                            />
                          }
                          label={
                            <Typography fontSize="14px">{text}</Typography>
                          }
                        />
                      </Grid>
                    )
                  })}
                </CheckList>
              </Grid>
            )
          }}
        />
      </Grid>
      <Grid container mt={5}>
        <PostponedFormActionButtons onSubmit={onSubmit} />
      </Grid>
    </>
  )
}

export default ProductInterestsForm
